/**
 * Keeps a final short identifier with the token before it, avoiding orphaned
 * suffixes such as a building wing rendered on a line by itself.
 */
export function noOrphanSuffix(text: string): string {
  return text.replace(/\s+(\S+)$/, "\u00a0$1");
}
